import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { ProductUpdate } from '../../services';

export const fetchProductUpdate = createAsyncThunk(
    'productUpdate/fetchProductUpdate',
    async ({ id, filesToKeep, file, slug, title, description, content, sort }) => {
        const response = await ProductUpdate(id, file, slug, title, description, content, sort, filesToKeep)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const productUpdateSlice = createSlice({
    name: 'productUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchProductUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchProductUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default productUpdateSlice.reducer;
